import { TAudio } from '../../spa/store/models/types';

// Mirrors ContentLibVideo's own "Create new book" condition: a transcript must exist and the
// recording must be done processing. Shared by Book/Exercises/Words, which all need a transcript.
export function hasUsableTranscript(audio?: TAudio): boolean {
	if (!audio) return false;
	const isProcessing = !audio.url && audio.unprocessed === undefined;
	return !!audio.captionsCount && !isProcessing && !audio.unprocessed;
}
